import React, { CSSProperties, FC } from 'react';
import copyIcon from '../../asset/copy.svg';
import './index.css';

interface CopyProps {
  style?: CSSProperties;
  text: string | number;
  title?: string;
}

const Copy: FC<CopyProps> = ({ text, style, title }) => {
  const onClickHandler = (): void => {
    navigator.clipboard.writeText(text.toString());
    const [copyModalWindow]: HTMLCollectionOf<Element> = document.getElementsByClassName(
      'copy-modal-window'
    );

    copyModalWindow.classList.remove('hidden');

    setTimeout(() => {
      copyModalWindow.classList.add('hidden');
    }, 1000);
  };
  return (
    <div className="wrapperDiv" onClick={onClickHandler} style={style}>
      <div title={title}>{text}</div>
      <img alt="copy icon" src={copyIcon} />
    </div>
  );
};

export default Copy;
